import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: UserTypes, Creators: UserActions } = createActions(
  {
    listenForUserData: [],
    bookingAdded: ['bookingId'],
    setIsBeingListened: ['isBeingListened'],
    setIsUpdating: ['isUpdating'],
    setIsChangingPassword: ['isChangingPassword'],
    setUserData: ['data'],
    clear: [],
  },
  { prefix: 'USER_' }
);

export const INITIAL_STATE = Immutable({
  isUpdating: false,
  isBeingListened: false,
  isChangingPassword: false,
  data: {},
});

const setUserData = (state, { data }) => state.set('data', data).set('isBeingListened', false);
const setIsBeingListened = (state, { isBeingListened }) => state.set('isBeingListened', isBeingListened);
const setIsUpdating = (state, { isUpdating }) => state.set('isUpdating', isUpdating);
const setIsChangingPassword = (state, { isChangingPassword }) => state.set('isChangingPassword', isChangingPassword);
const clear = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {
  [UserTypes.SET_USER_DATA]: setUserData,
  [UserTypes.SET_IS_BEING_LISTENED]: setIsBeingListened,
  [UserTypes.SET_IS_UPDATING]: setIsUpdating,
  [UserTypes.SET_IS_CHANGING_PASSWORD]: setIsChangingPassword,
  [UserTypes.CLEAR]: clear,
});
